import { Vector3 } from 'three';
import { degToRad } from 'three/src/math/MathUtils';

export function getPositionOnCircle(angle: number, radius: number, center?: [number, number, number]) {
    if (!center) {
        center = [0, 0, 0];
    }
    const x = Math.cos(degToRad(angle)) * radius + center[0];
    const y = Math.sin(degToRad(angle)) * radius + center[1];
    const z = center[2]

    console.log({ x, y, z })
    return new Vector3(x, y, z);
}

export function getRandomIntInclusive(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function shuffleAndCutStack(stack: number[], range?: number) {
    const temp = Object.assign([], stack);
    if (range) {
        return temp.sort(() => Math.random() - 0.5).slice(0, range);
    }
    return temp.sort(() => Math.random() - 0.5);
}

export function sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
}